export const tireGetDto = (mockData) => {
  return mockData.map((item) => ({
    codigo: item.codigo,
    stock: item.stock,
    marca: item.marca,
    trimarca: item.trimarca,
    valor_por_defecto_plp_simple: item.valor_por_defecto_plp_simple,
    valor_por_defecto_plp_doble: item.valor_por_defecto_plp_doble,
    valor_max_plp_simple: item.valor_max_plp_simple,
    valor_max_plp_doble: item.valor_max_plp_doble,
    icono_marca: item.icono_marca,
    precio_lista: item.precio_lista,
    precio_venta_web: item.precio_venta_web,
    markup: item.markup,
    precio_tachado: item.precio_tachado,
    diseno: item.diseno,
    ancho: item.ancho,
    perfil: item.perfil,
    aro: item.aro,
    carga: item.carga,
    velocidad: item.velocidad,
    equivalencia_carga: item.equivalencia_carga,
    equivalencia_velocidad: item.equivalencia_velocidad,
    lateral: item.lateral,
    descripcion: item.descripcion,
    descripcion_emocional: item.descripcion_emocional,
    imagen_performance: item.imagen_performance,
    caracteristicas: item.caracteristicas?.map((feature) => ({
      nombre: feature.nombre,
      valor: feature.valor,
    })) || [],
    disclaimer: item.disclaimer,
    audio: item.audio,
    icono_speaker: item.icono_speaker,
    corporativo: item.corporativo,
    estado: item.estado,
    uso_auto: item.uso_auto,
    icono_uso_auto: item.icono_uso_auto,
    texto_uso_auto: item.texto_uso_auto,
    foto_uso_auto: item.foto_uso_auto,
    uso_camioneta: item.uso_camioneta,
    icono_uso_camioneta: item.icono_uso_camioneta,
    texto_uso_camioneta: item.texto_uso_camioneta,
    foto_uso_camioneta: item.foto_uso_camioneta,
    uso_suv: item.uso_suv,
    icono_uso_suv: item.icono_uso_suv,
    texto_uso_suv: item.texto_uso_suv,
    foto_uso_suv: item.foto_uso_suv,
    uso_comercial: item.uso_comercial,
    icono_uso_comercial: item.icono_uso_comercial,
    texto_uso_comercial: item.texto_uso_comercial,
    foto_uso_comercial: item.foto_uso_comercial,
    uso_deportivo: item.uso_deportivo,
    icono_uso_deportivo: item.icono_uso_deportivo,
    texto_uso_deportivo: item.texto_uso_deportivo,
    foto_uso_deportivo: item.foto_uso_deportivo,
    uso_electrico: item.uso_electrico,
    icono_uso_electrico: item.icono_uso_electrico,
    texto_uso_electrico: item.texto_uso_electrico,
    foto_uso_electrico: item.foto_uso_electrico,
    porc_off_road: item.porc_off_road,
    icono_off_road: item.icono_off_road,
    porc_on_road: item.porc_on_road,
    icono_on_road: item.icono_on_road,
    icono_onoff_road: item.icono_onoff_road,
    texto_onoff_road: item.texto_onoff_road,
    foto_onoff_road: item.foto_onoff_road,
    reforzado: item.reforzado,
    icono_reforzado: item.icono_reforzado,
    run_flat: item.run_flat,
    icono_run_flat: item.icono_run_flat,


    texto_garantia_leon: item.texto_garantia_leon,
    banderin_garantia_leon: item.banderin_garantia_leon,
    icono_garantia_leon: item.icono_garantia_leon, //dc: este en el pennant
    icono_banderin_garantia_leon: item.icono_banderin_garantia_leon,

    texto_garantia_fabrica: item.texto_garantia_fabrica,
    banderin_garantia_fabrica: item.banderin_garantia_fabrica,
    icono_garantia_fabrica: item.icono_garantia_fabrica, //dc: este en el pennant
    icono_banderin_garantia_fabrica: item.icono_banderin_garantia_fabrica,
    
    icono_precio_internet: item.icono_precio_internet,
    imagen_360: item.imagen_360,
    icono_360: item.icono_360,
    rrss:
      item.rrss?.map((social) => ({
        link_facebook: social.link_facebook,
        icono_facebook: social.icono_facebook,
        link_twitter: social.link_twitter,
        icono_twitter: social.icono_twitter,
        link_whatsapp: social.link_whatsapp,
        icono_whatsapp: social.icono_whatsapp,
      })) || [],
    photos:
      item.fotos?.map((photo) => ({
        frente: photo.frente || null,
        diagonal: photo.diagonal || null,
        lado: photo.lado || null,
        detalle: photo.detalle || null,
        surco: photo.surco || null,
      })) || [],
    promociones: item.promociones || [],
  }));
};

export const tirePdpGetDto = (item) => ({
  codigo: item.codigo,
  stock: item.stock,
  marca: item.marca,
  trimarca: item.trimarca,
  valor_por_defecto_plp_simple: item.valor_por_defecto_plp_simple,
  valor_por_defecto_plp_doble: item.valor_por_defecto_plp_doble,
  valor_max_plp_simple: item.valor_max_plp_simple,
  valor_max_plp_doble: item.valor_max_plp_doble,
  icono_marca: item.icono_marca,
  precio_lista: item.precio_lista,
  precio_venta_web: item.precio_venta_web,
  markup: item.markup,
  precio_tachado: item.precio_tachado,
  diseno: item.diseno,
  ancho: item.ancho,
  perfil: item.perfil,
  aro: item.aro,
  carga: item.carga,
  velocidad: item.velocidad,
  equivalencia_carga: item.equivalencia_carga,
  equivalencia_velocidad: item.equivalencia_velocidad,
  lateral: item.lateral,
  descripcion: item.descripcion,
  descripcion_emocional: item.descripcion_emocional,
  imagen_performance: item.imagen_performance,
  caracteristicas: item.caracteristicas?.map((feature) => ({
    nombre: feature.nombre,
    valor: feature.valor,
  })) || [],
  audio: item.audio,
  icono_speaker: item.icono_speaker,
  corporativo: item.corporativo,
  estado: item.estado,
  uso_auto: item.uso_auto,
  icono_uso_auto: item.icono_uso_auto,
  texto_uso_auto: item.texto_uso_auto,
  foto_uso_auto: item.foto_uso_auto,
  uso_camioneta: item.uso_camioneta,
  icono_uso_camioneta: item.icono_uso_camioneta,
  texto_uso_camioneta: item.texto_uso_camioneta,
  foto_uso_camioneta: item.foto_uso_camioneta,
  uso_suv: item.uso_suv,
  icono_uso_suv: item.icono_uso_suv,
  texto_uso_suv: item.texto_uso_suv,
  foto_uso_suv: item.foto_uso_suv,
  uso_comercial: item.uso_comercial,
  icono_uso_comercial: item.icono_uso_comercial,
  texto_uso_comercial: item.texto_uso_comercial,
  foto_uso_comercial: item.foto_uso_comercial,
  uso_deportivo: item.uso_deportivo,
  icono_uso_deportivo: item.icono_uso_deportivo,
  texto_uso_deportivo: item.texto_uso_deportivo,
  foto_uso_deportivo: item.foto_uso_deportivo,
  uso_electrico: item.uso_electrico,
  icono_uso_electrico: item.icono_uso_electrico,
  texto_uso_electrico: item.texto_uso_electrico,
  foto_uso_electrico: item.foto_uso_electrico,
  porc_off_road: item.porc_off_road,
  icono_off_road: item.icono_off_road,
  porc_on_road: item.porc_on_road,
  icono_on_road: item.icono_on_road,
  icono_onoff_road: item.icono_onoff_road,
  texto_onoff_road: item.texto_onoff_road,
  foto_onoff_road: item.foto_onoff_road,
  reforzado: item.reforzado,
  icono_reforzado: item.icono_reforzado,
  run_flat: item.run_flat,
  icono_run_flat: item.icono_run_flat,

  texto_garantia_leon: item.texto_garantia_leon,
  icono_garantia_leon: item.icono_garantia_leon, // no uso
  icono_banderin_garantia_leon: item.icono_banderin_garantia_leon,
  banderin_garantia_leon: item.banderin_garantia_leon,
  banderin_garantia_fabrica: item.banderin_garantia_fabrica,

  texto_garantia_fabrica: item.texto_garantia_fabrica,
  icono_garantia_fabrica: item.icono_garantia_fabrica, //no uso
  icono_banderin_garantia_fabrica: item.icono_banderin_garantia_fabrica,


  icono_precio_internet: item.icono_precio_internet,
  imagen_360: item.imagen_360,
  icono_360: item.icono_360,
  rrss:
    item.rrss?.map((social) => ({
      link_facebook: social.link_facebook,
      icono_facebook: social.icono_facebook,
      link_twitter: social.link_twitter,
      icono_twitter: social.icono_twitter,
      link_whatsapp: social.link_whatsapp,
      icono_whatsapp: social.icono_whatsapp,
    })) || [],
  photos:
    item.fotos?.map((photo) => ({
      frente: photo.frente || null,
      diagonal: photo.diagonal || null,
      lado: photo.lado || null,
      detalle: photo.detalle || null,
      surco: photo.surco || null,
    })) || [],
  promociones: item.promociones || [],
});
